module.exports = __webpack_public_path__ + "img/home-footer-02.d208256e.png";